module.exports = __webpack_public_path__ + "static/media/bkg_square_2.e16a28a9.jpg";